import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ContractService } from 'src/app/services/contract.service';
import { ContractGroupEnum } from '../../../enumerators';

@Component({
  selector: 'app-upload-file-item-contract',
  templateUrl: './upload-file-item-contract.component.html',
  styleUrls: ['./upload-file-item-contract.component.css']
})
export class UploadFileItemContractComponent implements OnInit {

  uploadedFiles = [];
  isFileOpen: { state: boolean; url: any; isDWG: boolean } = { state: false, url: '', isDWG: false };
  saveFiles: boolean = false;
  contractGroups: typeof ContractGroupEnum = ContractGroupEnum;

  @Input() editFiles: [];
  @Input() type: string;
  @Input() index;
  @Output() uploadFiles = new EventEmitter<any>();
  @Output() deleteFiles = new EventEmitter<any>();

  constructor(
    private _sanitizer: DomSanitizer,
    private _contractService: ContractService,
  ) { }

  ngOnInit(): void {
    if (this.editFiles) {
      this.uploadedFiles = this.editFiles;
    }

  }

  uploadFile(file) {
    let objectURL = this._sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file[0]));
    this.uploadedFiles.push({ file: file[0], url: objectURL });

    this.uploadFiles.emit({ files: this.uploadedFiles, newFile: { file: file[0], url: objectURL } });

  }

  removeFile(fileName: string) {
    this.uploadedFiles.forEach((upFile, index) => {
      let uploadedFileName = upFile.file.originalName ?? upFile.file.name;
      if (uploadedFileName == fileName) {
        this.deleteFiles.emit(upFile);
        this.uploadedFiles.splice(index, 1);
      }
    });
    this.isFileOpen.state = false;
    this.uploadFiles.emit(this.uploadedFiles);
  }

  handleFileSelection(file: FileList) {
    let objectURL = this._sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file[0]));
    this.uploadedFiles.push({ file: file[0], url: objectURL });
    this.uploadFiles.emit({ files: this.uploadedFiles, newFile: { file: file[0], url: objectURL } });
  }

  openFile(file) {
    if (file.id) {
      if (this.type == ContractGroupEnum.vertical) {
        this._contractService.getContractVerticalItemFIle(file.id).subscribe((res) => {
          window.open(res.url);
        })
      }
      else if (this.type == ContractGroupEnum.horizontal) {
        this._contractService.getContractHorizontalItemFIle(file.id).subscribe((res) => {
          window.open(res.url);
        })

      }
      else if (this.type == ContractGroupEnum.device) {
        this._contractService.getContractDeviceItemFIle(file.id).subscribe((res) => {
          window.open(res.url);
        })

      }
      else if (this.type == ContractGroupEnum.services) {
        this._contractService.getContractServiceItemFIle(file.id).subscribe((res) => {
          window.open(res.url);
        })

      }
      else if (this.type == ContractGroupEnum.auxiliar) {
        this._contractService.getContractAuxiliarItemFIle(file.id).subscribe((res) => {
          window.open(res.url);
        })

      }

    } else window.open(file.url.changingThisBreaksApplicationSecurity);

  }

  cancelUpload() {
    this.uploadedFiles = [];
    this.uploadFiles.emit(this.uploadedFiles);
  }

  setMasterFile(indexOfFile) {
    this.uploadedFiles.forEach((file, index) => {
      if (index != indexOfFile) file.masterFile = false
      else file.masterFile = true
    })
  }
}
